//Styles
import { getStyles } from '@kubit/web-ui-components';
import styled from 'styled-components';
import { getContainerWaveHeaderStyles, getContainerWaveLogoStyles, } from '../../utils/container-wave-styles/container-wave.styled';
export const ContainerWaveStyled = styled.header `
  ${({ styles }) => {
    return getStyles(styles?.container);
}}
`;
ContainerWaveStyled.displayName = 'ContainerWaveStyled';
export const LeftBorderRadiousStyled = styled.div `
  clip-path: path('M0, 0 H100 V100 H0 Z M100, 0 Q48 48 100 100 Z');
  ${({ styles }) => {
    return getStyles(styles?.borderLeft);
}}
`;
LeftBorderRadiousStyled.displayName = 'LeftBorderRadiousStyled';
export const RightBorderRadiousStyled = styled.div `
  ${({ styles }) => {
    return getStyles(styles?.borderRight);
}}
`;
RightBorderRadiousStyled.displayName = 'RightBorderRadiousStyled';
export const ContainerWaveBordersStyled = styled.div `
  ${({ styles }) => {
    return getStyles(styles?.containerWithBorders);
}}
`;
ContainerWaveBordersStyled.displayName = 'ContainerWaveBordersStyled';
export const ChildrenContainerWaveStyled = styled.div `
  ${({ styles }) => {
    return getStyles(styles?.children);
}}
`;
ChildrenContainerWaveStyled.displayName = 'ChildrenContainerWaveStyled';
export const ContainerHeaderStyled = styled.div `
  ${({ hasLeftButton = false, hasRightButton = false, hasIllustration = false }) => getContainerWaveHeaderStyles(hasLeftButton, hasRightButton, hasIllustration)};

  ${({ styles }) => {
    return getStyles(styles?.containerHeader);
}}
`;
ContainerHeaderStyled.displayName = 'ContainerHeaderStyled';
export const ContainerBackButtonStyled = styled.div `
  ${({ styles }) => {
    return getStyles(styles?.containerBackButton);
}}
`;
ContainerBackButtonStyled.displayName = 'ContainerBackButtonStyled';
export const ContainerFooterStyled = styled.div `
  ${({ styles }) => {
    return getStyles(styles?.containerFooter);
}}
`;
ContainerFooterStyled.displayName = 'ContainerFooterStyled';
export const ContainerRightButtonStyled = styled.div `
  ${({ styles }) => {
    return getStyles(styles?.rightButton);
}}
`;
ContainerRightButtonStyled.displayName = 'ContainerRightButtonStyled';
export const ContainerHeaderLogoStyled = styled.div `
  ${({ hasIllustration = false }) => getContainerWaveLogoStyles(hasIllustration)};
  ${({ styles }) => {
    return getStyles(styles?.headerLogo);
}}
`;
ContainerHeaderLogoStyled.displayName = 'ContainerHeaderLogoStyled';
export const BackgroundStyled = styled.img `
  ${({ styles }) => {
    return getStyles(styles?.headerBackgroundImage);
}}
`;
BackgroundStyled.displayName = 'BackgroundStyled';
export const ContainerIllustrationStyled = styled.div `
  ${({ styles }) => {
    return getStyles(styles?.containerIllustrationStyled);
}}
`;
ContainerIllustrationStyled.displayName = 'ContainerIllustrationStyled';
//# sourceMappingURL=container-wave.component.styled.js.map